export function detectBrowserLanguage(): "en" | "de" {
	const langs = navigator.languages && navigator.languages.length > 0 ? navigator.languages : [navigator.language];

	for (const lang of langs) {
		if (lang.toLowerCase().startsWith("de")) {
			return "de";
		}

		if (lang.toLowerCase().startsWith("en")) {
			return "en";
		}
	}

	return "en";
}
